<template>
  <div class="login-form login-signin">
    <div class="text-center mb-10 mb-lg-20">
      <h3 class="font-size-h1">{{ $t("DRIVER_ACCESS.LOGIN_TITLE") }}</h3>
    </div>

    <b-form class="form" @submit.stop.prevent="onSubmit">
      <div role="alert" class="alert alert-dark">
        <div class="alert-text">
          {{ $t("DRIVER_ACCESS.LOGIN_HELP") }}
        </div>
      </div>

      <div v-if="errors.length" role="alert" class="alert alert-danger">
        <div v-for="(error, index) in errors" :key="index" class="alert-text">
          {{ error }}
        </div>
      </div>

      <div v-if="successMessage" role="alert" class="alert alert-success">
        <div class="alert-text">
          {{ successMessage }}
        </div>
      </div>

      <b-form-group class="pb-3" label-for="driver-registration-plate">
        <b-form-input
          id="driver-registration-plate"
          v-model.trim="form.registrationPlate"
          class="form-control form-control-solid h-auto py-5 px-6"
          :placeholder="$t('DRIVER_ACCESS.REGISTRATION_PLATE')"
        />
      </b-form-group>

      <b-form-group label-for="driver-password">
        <b-form-input
          id="driver-password"
          v-model="form.password"
          class="form-control form-control-solid h-auto py-5 px-6"
          type="password"
          :placeholder="$t('DRIVER_ACCESS.PASSWORD')"
        />
      </b-form-group>

      <div class="form-group d-flex justify-content-end">
        <button
          ref="submit"
          type="submit"
          class="btn btn-dark font-weight-bold px-9 py-4 my-3 font-size-3"
        >
          {{ $t("DRIVER_ACCESS.LOGIN_BUTTON") }}
        </button>
      </div>
    </b-form>
  </div>
</template>

<script>
import DriverAccessService from "@/modules/driver-access/services/driver-access.service";

export default {
  name: "driver-login",
  data() {
    return {
      form: {
        registrationPlate: "",
        password: ""
      },
      successMessage: "",
      errors: []
    };
  },
  mounted() {
    if (DriverAccessService.hasToken()) {
      this.$router.push({ name: "driver-machine" });
    }
  },
  methods: {
    onSubmit() {
      this.errors = [];
      this.successMessage = "";

      if (!this.form.registrationPlate || !this.form.password) {
        this.errors = [this.$t("DRIVER_ACCESS.REQUIRED_LOGIN_FIELDS")];
        return;
      }

      const submitButton = this.$refs.submit;
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      DriverAccessService.login(this.form)
        .then(response => {
          if (
            response.data &&
            (response.data.accessToken || response.data.access_token)
          ) {
            this.$router.push({ name: "driver-machine" });
            return;
          }

          this.successMessage =
            response.message || this.$t("DRIVER_ACCESS.LOGIN_SUCCESS");
        })
        .catch(({ response }) => {
          this.errors = this.extractErrors(response);
        })
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
    extractErrors(response) {
      if (!response || !response.data) {
        return [this.$t("DRIVER_ACCESS.LOGIN_ERROR")];
      }

      if (Array.isArray(response.data.message)) {
        return response.data.message;
      }

      if (response.data.message) {
        return [response.data.message];
      }

      return [this.$t("DRIVER_ACCESS.INVALID_LOGIN")];
    }
  }
};
</script>
